import Loadable from 'react/components/loadable';

const BulkAddAttendeesList = Loadable({
  loader: () => import('../../../pages/event_defaults/bulk_add_event/bulk_add_attendees_list'),
});

angular.module('gym').value('BulkAddAttendeesList', BulkAddAttendeesList);
